var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"table_textarea_cell",staticStyle:{"-webkit-box-orient":"vertical"},attrs:{"title":_vm.value},domProps:{"innerHTML":_vm._s(_vm.value.replace(/\n/g, '</br>'))}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10f809a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableTextareaCell/TableTextareaCell.vue
// module id = null
// module chunks = 